import { useNavigate } from "react-router-dom";
import CreateProjectCard from "./CreateProjectCard";
import ProjectCard from "./ProjectCard";
import { Project } from "@/hooks/useProjects";

interface ProjectsGridProps {
  projects: Project[];
  onCreateProject?: () => void;
  onRename?: (id: string) => void;
  onArchive?: (id: string) => void;
  onRestore?: (id: string) => void;
  onDelete?: (id: string) => void;
  canCreateProject?: boolean;
  projectLimit?: number;
  activeProjectCount?: number;
}

const ProjectsGrid = ({
  projects,
  onCreateProject,
  onRename,
  onArchive,
  onRestore,
  onDelete,
  canCreateProject = true,
  projectLimit,
  activeProjectCount,
}: ProjectsGridProps) => {
  const navigate = useNavigate();
  const activeProjects = projects.filter((p) => p.status === "active");
  const archivedProjects = projects.filter((p) => p.status === "archived");

  const handleCreateClick = () => {
    if (canCreateProject) {
      onCreateProject?.();
    } else {
      navigate('/plans');
    }
  };

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {/* Create New Project Card */}
      <CreateProjectCard 
        onClick={handleCreateClick} 
        disabled={!canCreateProject}
        projectLimit={projectLimit}
        activeProjectCount={activeProjectCount}
      />

      {/* Active Projects */}
      {activeProjects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onRename={onRename}
          onArchive={onArchive}
          onDelete={onDelete}
        />
      ))}

      {/* Archived Projects */}
      {archivedProjects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onRestore={onRestore}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default ProjectsGrid;
